var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "bowls-sl",
  "use": "bowls-sl-usage",
  "viewBox": "0 0 30 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 32\" id=\"bowls-sl\"><path d=\"M12.512 0c6.91 0 12.512 5.602 12.512 12.512s-5.602 12.512-12.512 12.512S0 19.422 0 12.512 5.602 0 12.512 0z\" /><path fill=\"none\" stroke=\"#735e1f\" stroke-width=\"1.564\" d=\"M24.633 22.209a4.504 4.504 0 1 1-4.504 4.504 4.504 4.504 0 0 1 4.504-4.504z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id